import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-1000">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" data-id="element-1001" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-1002">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-[#0a0a1a] border border-white/10 w-full max-w-3xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col pointer-events-auto overflow-hidden" data-id="element-1003">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/10 bg-[#0a0a1a]" data-id="element-1004">
                <h3 className="text-xl md:text-2xl font-bold font-orbitron text-white" data-id="element-1005">
                  {title}
                </h3>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-white/10 text-gray-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-1006">
                  <X className="w-6 h-6" data-id="element-1007" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-gray-300 space-y-4 leading-relaxed" data-id="element-1008">
                {children}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-white/10 bg-[#0a0a1a] flex justify-end" data-id="element-1009">
                <button onClick={onClose} className="px-6 py-2 rounded-full bg-white text-black font-bold text-sm hover:bg-gray-200 transition-colors" data-id="element-1010">
                  Entendido
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}